import FormPropsType from "@/lib/types/interactions/forms/FormProps.type";
import { CSSProperties } from "react";

export default function Form({
  boxShadow = true,
  children,
  className,
  id,
  onSubmit,
  style,
}: FormPropsType) {
  const styles: CSSProperties = {
    backgroundColor: "var(--color-background-frame)",
    boxShadow: boxShadow
      ? "var(--box-shadow-color) var(--box-shadow-offset)"
      : "none",
    borderRadius: "var(--border-radius-md)",

    display: "flex",
    flexDirection: "column",
    gap: "var(--spacing-lg)",
    alignSelf: "stretch",

    margin: "0 auto",
    padding: "var(--spacing-2xl)",
    width: "100%",
    maxWidth: "40rem",
    ...style,
  };

  return (
    <form className={className} id={id} onSubmit={onSubmit} style={styles}>
      {children}
    </form>
  );
}
